import { ComparativePrice } from './ComparativePrice';
import { Error, ErrorCode } from './Error';
import { ReferencedProduct } from './ReferencedProduct';
import { ThirdPriceDeviation } from './ThirdPriceDeviation';

export class FinalCalculation {
	constructor(
		public readonly comparativePrice: ComparativePrice | null,
		public readonly thirdPriceDeviation: ThirdPriceDeviation | null,
		public readonly potentialPriceDropPercents: number,
		public readonly referencedProduct: ReferencedProduct | null,
		public readonly emptyResultReason: Error[]
	) {}

	hasMissingProductSettings(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiredProductSettingsMissing) !== undefined
		);
	}

	requiresMinOneReferenceProductErrorCode(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMinOneReferenceProduct) !== undefined
		);
	}

	findMaxOneReferenceProductError(): Error | null {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMaxOneReferenceProduct) ?? null;
	}

	isMissingReferenceSettings(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresReferenceSettings) !== undefined;
	}

	isIllegalProductPriceTypeSelected(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.illegalPriceTypeSelected) !== undefined;
	}
}
